import React, { useState, useEffect, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import NoIndex from "../NoIndex";

import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl, Modal } from "react-bootstrap";
import Pagination from "./Pagination";
import eye from "../../images/EYE.png";
import trash from "../../images/Red-Delete.svg";
import refreshicon from "../../images/refresh-2.svg";
import Edit from "../../images/message-edit.png";
import { useNavigate } from "react-router-dom";
import loader from "../../images/msgnotifier.svg"
import MyContext from "../../MyContext";
import Swal from "sweetalert2";



const DLTTamplate = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [templates, setTemplates] = useState([]);
  const [deleteState, setdeleteState] = useState("");
  const [ErrorDelete, setErrorDelete] = useState();
  const [isModalOpen, setModalOpen] = useState(false);
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");

  const handleSend = (data) => {
    console.log("Message Sent:", data);
  };

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    userid: userID,
  });
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [ModalData, setModalData] = useState("");
  const itemsPerPage = 10; // Show 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [ExcuteDelete, setExcuteDelete] = useState("");


  const handleClick = (type) => {
    if (type === "prev") {
      setCurrentPage(currentPage === 1 ? 1 : currentPage - 1);
    } else if (type === "next") {
      setCurrentPage(currentPage === totalPages ? totalPages : currentPage + 1);
    }
  };
  const handlePageClick = (pageNumber) => {
    if (
      pageNumber !== currentPage &&
      pageNumber >= 1 &&
      pageNumber <= totalPages
    ) {
      setCurrentPage(pageNumber);
      // Perform any action here, like fetching data for the new page
    }
  };

  const navigate = useNavigate();

  function handleView(id, name) {
    navigate(`/WhatsApp/TemplateView?templateID=${id}&templateName=${name}`);
  }
  function handleEdit(index) {
    navigate(`/WhatsApp/Template/TemplateEdit?templateId=${index}`);
  }

  var requestOptions = {
    method: "POST",
    headers: {
      ...config.headers, // Using headers from config
    },
    body: raw,
    redirect: "follow",
  };

  let url = `${baseUrl}/api/Whatsapp/getTemplates`;
  async function fetchJson(url, a) {
    try {
      let response = await fetch(url, a);
      if (!response.ok) {
        throw new Error("Failed to fetch data. Status:", response.status);
      }
      const jsonData = await response.json({
        userid: userID,
        secret: "string",
      });
      return jsonData;
    } catch (error) {
      console.error("An json function error occurred:", error);
      return null;
    }
  }

  const getVendorAccounts = async (e) => {
    try {
      setLoading(true);

      var raw = JSON.stringify({
        userid: userID,
        phoneNumberId: SingleWhatsApp
      });

      var requestOptions = {
        method: "POST",
        headers: config.headers, // Using headers from config
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getTemplates`,
        requestOptions,
      );

      const data = await res.json();

      if (data?.responseCode == "00") {
        setTemplates(data?.response.data);
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };
  useEffect(() => {
    getVendorAccounts();
  }, [SingleWhatsApp]);
  //geting Whatsapp number register
  const getWhatsappNumber = async (e) => {
    try {

      var raw = JSON.stringify({
        userid: userID,
      });
      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`,
        requestOptions,
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setWhatsappNumbers(data?.response);
      } else {
      }
    } catch (error) { }
  };
  useEffect(() => {
    getWhatsappNumber();
  }, []);
  useEffect(() => {
    if (WhatsappNumbers && WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      WhatsappNumbers.map((Num, i) => setSingleWhatsApp(Num.phone_no_id));
    } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
      setMultiplePhoneNumber(true);
      WhatsappNumbers.map((Num, i) => i === 0 ? setSingleWhatsApp(Num.phone_no_id) : "");
    }
  }, [WhatsappNumbers]);

  const data = templates?.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.language.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.category.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const data2 = templates?.filter((item) =>
    item.language.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex =
    currentPage === totalPages ? templates?.length : startIndex + itemsPerPage;
  const currentItems = data?.slice(startIndex, endIndex);

  // edit delete and view hover diaogbox
  useEffect(() => {
    // Initialize tooltips when component mounts
    const tooltips = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltips?.map((tooltip) => new window.bootstrap.Tooltip(tooltip));
    // Clean up tooltips when component unmounts
    return () => {
      tooltips?.map((tooltip) => tooltip?.dispose());
    };
  }, []);

  function refresh() {
    getVendorAccounts();
  }

  const deleteTemplate = async (templateId, templateName) => {
    try {
      // Ask for confirmation first
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `Delete template "${templateName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        allowOutsideClick: false,
      });

      if (!result.isConfirmed) return; // user cancelled

      setLoading(true);

      const raw = JSON.stringify({
        userid: userID,
        templateId: templateId, // <-- use id for API
      });

      const requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(`${baseUrl}/api/Whatsapp/deleteTemplate`, requestOptions);
      const data = await res.json();

      if (data?.responseCode === "00") {
        // You can keep toast or just swal; using swal here for a single UX pattern
        await Swal.fire({
          title: "Deleted!",
          text: data?.responseMessage || "Template deleted successfully.",
          icon: "success",
        });
        getVendorAccounts(); // refresh list
      } else {
        await Swal.fire({
          title: "Error",
          text: data?.responseMessage || "Failed to delete template.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Delete error:", error);
      await Swal.fire({
        title: "Error",
        text: "Something went wrong while deleting the template.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <NoIndex />
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>
      <div
        className="p-4 bg-white"
        style={{
          // backgroundColor: "#F8F8F8",
          fontFamily: "Nunito, sans-serif",
        }}
      >
        {/* <DynamicTemplateModal/> */}
        <div className="bg-white px-4">
          <div className="Message-Notifier-campaign-container mb-4 bg-light">
            {/* Header Section */}
            <div className="Message-Notifier-header d-flex justify-content-between">
              <h2 className="CreateCampaign"> Template Status</h2>
              <div className="d-flex">

                {/* Action Buttons */}
                <div className="Message-Notifier-actions">
                  <button className="Message-Notifier-create-btn" onClick={() => navigate("/WhatsApp/Create-Template")}>
                    + Create New Template
                  </button>
                  <button className="Message-Notifier-refresh-btn" onClick={() => refresh()}>
                    <img src={refreshicon} alt="Refresh" />
                  </button>
                </div>
              </div>
            </div>

            <hr />

            {/* Top Controls - Search & WhatsApp Number */}
            <div className="Message-Notifier-controls d-flex justify-content-start">
              <div className="Message-Notifier-whatsapp ">
                <label className="Message-Notifier-whatsapp-label single-line-css" > WhatsApp Number</label>
                <select
                  className="Message-Notifier-whatsapp-dropdown"
                  value={SingleWhatsApp}
                  onChange={(e) => setSingleWhatsApp(e.target.value)}
                  disabled={!MultiplePhoneNumber}
                >
                  <option value="">Select Number</option>
                  {WhatsappNumbers.map((num, index) => (
                    <option key={index} value={num.phone_no_id}>
                      {num.phone_no_id} - ({num.phone_no})
                    </option>
                  ))}
                </select>
              </div>
              <div className="Message-Notifier-whatsapp ">
                <label className="Message-Notifier-whatsapp-label single-line-css" > Search Template</label>
                <Form>
                  <FormControl
                    type="text"
                    placeholder=" Search Template..."
                    value={searchTerm}
                    className="Message-Notifier-search-input"
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Form>
              </div>


            </div>


          </div>



          {loading ? (
            <div className=" m-5 p-5 d-flex justify-content-center">
              <div className=" d-flex flex-column align-items-center justify-content-center ">
                <div className="p-3">
                  <div className="loader"> </div>
                </div>
                <div className="p-3">
                  <img src={loader} alt="" height={40} />
                </div>
              </div>
            </div>
          ) : (
            <React.Fragment
              className=""
              style={{
                border: "1px solid #dddddd",
                borderRadius: "10px",
              }}
            >
              <div className="scrollable-table">
                <table className="table table-bordered table-hover"

                >

                  <thead style={{ borderRadius: "10px" }}>
                    <tr className="text-center greenColour  py-4">
                      <th className="pb-3 th-style">S.No.</th>
                      <th
                        className="pb-3 th-style"

                      >
                        Template ID
                      </th>
                      <th
                        className="pb-3 th-style"

                      >
                        Template Name
                      </th>

                      <th
                        className="pb-3 th-style"

                      >
                        {" "}
                        Language
                      </th>

                      <th
                        className="pb-3 th-style"

                      >
                        Category
                      </th>

                      <th
                        className="pb-3 th-style"

                      >
                        Status
                      </th>

                      <th
                        className="pb-3 th-style"

                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems?.map((item, index) => (
                      <tr
                        key={index}
                        style={
                          {
                            // borderBottom: "1px solid #DDD",
                            // padding: "5px 0px",
                          }
                        }
                      >
                        <td className="pt-4 text-center">
                          {index + startIndex + 1}
                        </td>
                        <td className="pt-4 text-center">
                          {item.id}
                          {/* <button className={`gap-10 ${item.status === "APPROVED" ? "use-template" : "not-use-template disabled"}`}>
                            {item.status === "APPROVED" ? (
                              <>Use Template</>
                            ) : (
                              <>Use Template</>
                            )}
                          </button> */}
                        </td>
                        <td className="pt-4 text-center">{item.name}</td>

                        <td className="pt-4 text-center">{item.language}</td>
                        <td className="pt-4 text-center">{item.category}</td>

                        <td className="pt-4 text-center">
                          {item.status === "APPROVED" ? (
                            <span
                              className=" text-center w-100  px-3 py-1"
                              style={{
                                width: "91px",
                                height: "31px",
                                borderRadius: "50px",
                                color: " rgba(1, 195, 125, 1)",
                                background: " rgba(242, 252, 248, 1)",
                                fontWeight: "bold",
                              }}
                            >
                              Approved
                            </span>
                          ) : (
                            <span
                              className=" text-center w-100  px-3 py-1"
                              style={{
                                width: "91px",
                                height: "31px",

                                borderRadius: "50px",
                                color: "rgba(255, 72, 72, 1)",
                                background: " rgba(255, 224, 224, 1)",
                                fontWeight: "bold",
                              }}
                            >
                              {item.status}
                            </span>
                          )}
                        </td>

                        <td className=" d-flex justify-content-center ">
                          <div
                            className="d-flex justify-content-center align-items-center gap-4"
                            style={{ height: "50px" }}
                          >
                            <span
                              className="cursor-pointer"
                              data-bs-placement="bottom"
                              title="View"
                              onClick={() => {
                                handleView(item.id, item.name);
                              }}
                            >
                              <img src={eye} alt="Logo" />
                            </span>

                            <div
                              className="cursor-pointer"
                              onClick={() => deleteTemplate(item.id, item.name)}
                            >
                              <img src={trash} alt="Logo" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          )}



          {/* {pagination} */}
          <div>
            {loading === false ? (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onNextPage={() => handleClick("next")}
                onPrevPage={() => handleClick("prev")}
                onPageClick={(e) => handlePageClick(e)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};


export default DLTTamplate;   
